// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var AggregateField$ReactHooksTemplate = require("./AggregateField.res.js");
var AggregateReport$ReactHooksTemplate = require("./AggregateReport.res.js");

function AggregateReportForm(props) {
  var handleAggregateReportChange = props.handleAggregateReportChange;
  var template = props.template;
  var metric = AggregateReport$ReactHooksTemplate.metric(template);
  var aggregateField = AggregateReport$ReactHooksTemplate.aggregateFields(template);
  var tmp;
  if (aggregateField !== undefined) {
    var dataField = AggregateField$ReactHooksTemplate.dataField(aggregateField);
    tmp = dataField !== undefined ? DataField$ReactHooksTemplate.name(Caml_option.valFromOption(dataField)) : "Select DataField";
  } else {
    tmp = "Select DataField";
  }
  var aggregateField$1 = AggregateReport$ReactHooksTemplate.aggregateFields(template);
  var tmp$1;
  if (aggregateField$1 !== undefined && AggregateField$ReactHooksTemplate.isTimestamp(aggregateField$1)) {
    var aggregateField$2 = AggregateReport$ReactHooksTemplate.aggregateFields(template);
    var tmp$2;
    if (aggregateField$2 !== undefined) {
      var timeFrame = AggregateField$ReactHooksTemplate.timeFrame(aggregateField$2);
      tmp$2 = timeFrame !== undefined ? AggregateField$ReactHooksTemplate.timeFrameToString(timeFrame) : "Select Timeframe";
    } else {
      tmp$2 = "Select Timeframe";
    }
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: "Group by",
                        className: "text-sm font-medium w-1/5"
                      }),
                  JsxRuntime.jsxs("select", {
                        children: [
                          JsxRuntime.jsx("option", {
                                children: "Select Timeframe",
                                disabled: true,
                                value: "Select Timeframe"
                              }, "0"),
                          $$Array.of_list(Belt_List.map(AggregateField$ReactHooksTemplate.timeFrames, (function (timeFrame) {
                                      return JsxRuntime.jsx("option", {
                                                  children: timeFrame,
                                                  value: timeFrame
                                                }, timeFrame);
                                    })))
                        ],
                        className: "block border px-3 py-2 border-gray-400\n                                w-3/5 bg-white rounded capitalize mr-6 text-sm",
                        placeholder: "Select Timeframe",
                        value: tmp$2,
                        onChange: Curry._2(handleAggregateReportChange, template, "timeFrame")
                      })
                ],
                className: "flex gap-1 items-center w-full"
              }),
          className: "flex mb-30-px items-center"
        });
  } else {
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: "Aggregate Report Fields",
                                  className: "text-sm font-bold"
                                }),
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-20-px items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Metric",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsxs("select", {
                                    children: [
                                      JsxRuntime.jsx("option", {
                                            children: "Select Metric",
                                            disabled: true,
                                            value: "Select Metric"
                                          }, "0"),
                                      $$Array.of_list(Belt_List.map(AggregateReport$ReactHooksTemplate.metrics, (function (metricString) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: metricString,
                                                              value: metricString
                                                            }, metricString);
                                                })))
                                    ],
                                    className: "block border px-3 py-2 border-gray-400\n                      w-3/5 bg-white rounded capitalize mr-6 text-sm",
                                    placeholder: "Select Metric",
                                    value: metric !== undefined ? AggregateReport$ReactHooksTemplate.metricToString(metric) : "Select Metric",
                                    onChange: Curry._2(handleAggregateReportChange, template, "metric")
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "DataField",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsxs("select", {
                                    children: [
                                      JsxRuntime.jsx("option", {
                                            children: "Select DataField",
                                            disabled: true,
                                            value: "Select DataField"
                                          }, "0"),
                                      $$Array.of_list(Belt_List.map(props.dataFields, (function (dataField) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: DataField$ReactHooksTemplate.name(dataField),
                                                              value: DataField$ReactHooksTemplate.name(dataField)
                                                            }, String(Belt_Option.getExn(DataField$ReactHooksTemplate.id(dataField))));
                                                })))
                                    ],
                                    className: "block border px-3 py-2 border-gray-400\n                      w-3/5 bg-white rounded mr-6 text-sm",
                                    placeholder: "Select DataField",
                                    value: tmp,
                                    onChange: Curry._2(handleAggregateReportChange, template, "dataField")
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px items-center"
                    }),
                tmp$1
              ]
            });
}

var make = AggregateReportForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
